"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LoadingOverlay = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 20;
  background: rgba(173, 173, 173, 0.44);
`;
//# sourceMappingURL=loading-overlay.js.map